import React from "react";
import { Link, useNavigate } from "react-router-dom";
import Clock from "./assets/clock.svg";
import PhoneCallIcon from "./assets/phone-call.svg";
import Globe from "./assets/globe.svg";
import championsLeagueLogo from "./assets/championsleague.png";
import lauraAvatar from "./assets/laura.jpg";
import calendlyLogo from "./assets/calendly.svg";
import CurrentTime from "./CurrenTime";
import "./App.css";

export default function CalendlySchedule() {
  const API_URL = process.env.REACT_APP_API_BASE_URL;
  const navigate = useNavigate();

  const handleGoogleLogin = async () => {
    try {
      let sessionId = localStorage.getItem("session_id");

      if (!sessionId) {
        const response = await fetch(`${API_URL}/api/new-user`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
        });

        if (!response.ok) throw new Error("Failed to create session");

        const data = await response.json();
        sessionId = data.session_id;
        localStorage.setItem("session_id", sessionId);
      }

      localStorage.removeItem(`confirmation_done_${sessionId}`);

      navigate("/login");
    } catch (error) {
      console.error("Login error:", error);
      alert("An error occurred. Please try again.");
    }
  };

  return (
    <div className="calendy-div">
      <div className="calendy-grid">
        <div className="left-side">
          <div className="left-side-content">
            <div className="logo-avatar-group">
              <img src={championsLeagueLogo} alt="Champions League" className="nike-logo" />
              <div className="avatar-container">
                <img src={lauraAvatar} alt="Laura Vieira" className="avatar-image" />
              </div>
            </div>
            <h3>Laura Vieira</h3>
            <h2>30 Minute Meeting</h2>
            <div></div>
            <div className="calendy-div-icons">
              <div className="calendy-icons">
                <img src={Clock} alt="clock" className="icon" />
                <span>30 min</span>
              </div>
              <div className="calendy-icons" style={{ gap: "15px" }}>
                <img src={PhoneCallIcon} alt="phone call" className="icon phone-icon" />
                <span>Phone call</span>
              </div>
              <div className="calendy-icons">
                <img src={Globe} alt="globe" className="icon globe-icon" />
                <CurrentTime />
              </div>
            </div>
          </div>
          <div className="footer-links">
            <a>Cookie settings</a>
            <a>Report abuse</a>
          </div>
        </div>

        <div className="right-side">
          <Link className="VJL48qbQzWENTFAh1Knk e9TS9yoMqqIN2PqBo1QG _i6SG2jlTfccH2ZZblil">
            <div data-id="branding" className="jWSwi_R_Xl7kPjUhuQoo _igrKj_5lj_5nWQu8DPw">
              <div className="V7YfvNqWv0XKYKys7N7K __d5yUqDgBEjoX7J2dql">powered by</div>
              <div className="HvybhIo63ZbBJxHh7Ann RK3ps09FjZwzHTaYDakl">Calendly</div>
            </div>
          </Link>

          <div className="step-content step-finish calendly-google-intro">
            <div className="calendly-intro-brand">
              <img src={calendlyLogo} alt="Calendly" className="calendly-intro-logo" />
            </div>
            <h2>Schedule Call With Laura Vieira</h2>
            <div className="confirmation-message calendly-signup-callout">
              <p>
                The easiest way for you to sign up is with Google. This will automatically connect your calendar so you
                can start using Calendly right away.
              </p>
            </div>
            <div className="social-login-container">
              <button type="button" className="google-login-btn" onClick={handleGoogleLogin}>
                <svg width="20" height="20" viewBox="0 0 18 18" xmlns="http://www.w3.org/2000/svg">
                  <path
                    fill="#4285F4"
                    d="M17.64 9.2c0-.637-.057-1.251-.164-1.84H9v3.481h4.844c-.209 1.125-.843 2.078-1.796 2.717v2.258h2.908c1.702-1.567 2.684-3.874 2.684-6.615z"
                  />
                  <path
                    fill="#34A853"
                    d="M9 18c2.43 0 4.467-.806 5.956-2.184l-2.908-2.258c-.806.54-1.837.86-3.048.86-2.344 0-4.328-1.584-5.036-3.711H.957v2.332C2.438 15.983 5.482 18 9 18z"
                  />
                  <path
                    fill="#FBBC05"
                    d="M3.964 10.707c-.18-.54-.282-1.117-.282-1.707s.102-1.167.282-1.707V4.951H.957C.348 6.174 0 7.55 0 9s.348 2.826.957 4.049l3.007-2.342z"
                  />
                  <path
                    fill="#EA4335"
                    d="M9 3.58c1.321 0 2.508.454 3.44 1.345l2.582-2.582C13.463.891 11.426 0 9 0 5.482 0 2.438 2.017.957 4.951L3.964 7.293C4.672 5.163 6.656 3.58 9 3.58z"
                  />
                </svg>
                Continue with Google
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
